<script setup>
import ga4 from '#common/utils/ga4'
import { FormKit } from '@formkit/vue'

const { $auth, $axios } = useNuxtApp()
const qesErrors = ref({})
const loading = ref(false)
const qes = computed(() => $auth.qes)

async function registerQes(data) {
  qesErrors.value = {}
  loading.value = true
  try {
    await $auth.registerQes(data)
    ga4.track('register')
    const result = await $axios.get('/api/customer/user/')
    $auth.setUser(result.data)
    setTimeout(() => {
      if ($auth.qes) {
        $auth.resetQes()
      }
    }, 5000)
  } catch (errors) {
    qesErrors.value = errors.response.data
  }
  loading.value = false
}
</script>

<template>
  <FormKit
    type="form"
    :actions="false"
    analytics-track="quickregPrompt"
    @submit="registerQes"
  >
    <div v-if="qes">
      <h2 role="heading" class="header" aria-level="1">
        Signed up for email offers
      </h2>
      <p>Thank you for Signing Up!</p>
      <p>
        Enjoy exploring our wines. If you ever need assistance, drop us a line
        at <CustomerServiceEmailLink />.
      </p>
    </div>
    <template v-else>
      <h2 role="heading" class="header" aria-level="1">
        Sign up for email offers
      </h2>
      <FormKit
        type="email"
        label="Email"
        label-class="sr-only"
        placeholder="Enter your email"
        validation="bail|required|email"
        name="qesEmail"
        maxlength="255"
      />
      <FormKit
        type="text"
        label="ZIP Code"
        label-class="sr-only"
        name="zipcode"
        placeholder="Enter your ZIP code"
        validation="bail|required|matches:/^\d{5}(?:-\d{4})?$/"
        :validation-messages="{
          matches: 'Error: You must input a valid US Zip Code',
        }"
      />
      <ErrorList :errors="Object.values(qesErrors)" />
      <FormKit type="submit" label="Sign Up" :disabled="loading" />
    </template>
  </FormKit>
</template>
